import { Controparte } from './controparte';
import { DocumentoAllegato } from './documento-allegato';
import { EsitoSpedizioneDiffida } from './esito-spedizione-diffida';
import { TipoLettera } from './tipologiche/tipo-lettera';

export class LetteraDiffida {
  id: string;
  tipoLettera: TipoLettera;
  dataLettera: number;
  mittente: string;
  destinatario: Controparte;
  note: string;
  documenti: DocumentoAllegato[];
  esitiSpedizioni: EsitoSpedizioneDiffida[];
}
